import { formatDate } from '@/web-task/filter.js'
import { zeroUnit } from '@/web-task/utils.js'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	const companySurvey = (injured && injured.workCompanySurvey) || {}

	let arr = [
		{
			label: '被询问人姓名',
			value: companySurvey.intervieweeName,
		},
		{
			label: '被询问人电话',
			value: companySurvey.intervieweePhone,
		},
		{
			label: '被询问人职位',
			value: companySurvey.intervieweeJob,
		},
		{
			label: '伤者是否在公司工作',
			value: setting.yesNoMap[companySurvey.injuredAtComppany],
		},
	]
	if (companySurvey && companySurvey.injuredAtComppany !== '0') {
		arr.push(
			{
				label: '实际公司名称',
				value: companySurvey.injuredWorkCompany,
			},
			{
				label: '公司所在地区',
				value: companySurvey.areaDesc,
			},
			{
				label: '详细地址',
				value: companySurvey.address,
			},
			{
				label: '公司性质',
				value: setting.companyTypeMap[companySurvey.companyType],
			},
			{
				label: '是否有合同',
				value: setting.contractTypeMap[companySurvey.contractType],
			},
			{
				label: '入职时间',
				value: formatDate(companySurvey.beginTime),
			},
			{
				label: '所属部门',
				value: companySurvey.department,
			},
			{
				label: '工作岗位',
				value: companySurvey.jobName,
			},
			{
				label: '工资收入组成',
				value: companySurvey.wageForm,
			},
			{
				label: '工资收入（月）',
				value: zeroUnit(companySurvey.wage, '元/月'),
			},
			{
				label: '工资发放形式',
				value: setting.wageTypeMap[companySurvey.wageType],
			},
			{
				label: '是否缴纳社保',
				value: setting.yesNoMap[companySurvey.socialSecurity],
			},
			{
				label: '是否缴纳公积金',
				value: setting.yesNoMap[companySurvey.accumulationFund],
			},
			{
				label: '请假类型',
				value: setting.leaveTypeMap[companySurvey.leaveType],
			},
			{
				label: '因事故请假后扣减金额',
				value: zeroUnit(companySurvey.leaveLossAmount, '元'),
			}
		)
	}
	arr.push(
		{
			label: '是否签字',
			value: setting.yesNoMap[companySurvey.sign],
		},
		{
			label:
				companySurvey && companySurvey.injuredAtComppany !== '0'
					? '备注（非必填）'
					: '备注（必填）',
			value: companySurvey.remark,
		}
	)
	return {
		title: '公司/单位询问笔录',
		children: arr,
	}
}
